module.exports = __webpack_public_path__ + "static/img/12.4ea7b6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/zh/12.png
// module id = /B46
// module chunks = 0